import React from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import UserBadgeComponent from '../../../../../components/UserBadge.component';
import { EmployeeForRender } from '../../../../../redux/Employee/Employee.type';
import { IControlDataItem } from '../../ControlPanel.types';
import { DATE_FORMAT } from '../../../../../constants/date.contant';

const StyledSelectOption = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  > div {
    flex: 1;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;

const StyledVisibilityDate = styled.div`
  flex-shrink: 0;
  font-size: 12px;
  color: #6b7280;
  max-width: 140px;
  text-align: right;
`;

const ControlHRItem = ({
  item,
  showVisibilityDate = false,
}: {
  item: IControlDataItem;
  showVisibilityDate?: boolean;
}) => {
  const { t } = useTranslation();

  const regionsAsString = item.regions
    ?.map(
      (r: {
        id: string | number;
        name: string;
        code: string;
        timezone: string;
      }) => r.name,
    )
    ?.join(', ');

  const visibilityLabel =
    item.hideCandidatesBefore != null
      ? t('From {{date}}', {
          date: dayjs(item.hideCandidatesBefore).format(DATE_FORMAT),
        })
      : null;

  return (
    <StyledSelectOption>
      <UserBadgeComponent info={item as EmployeeForRender} />
      <div title={regionsAsString}>{regionsAsString}</div>
      {showVisibilityDate && visibilityLabel && (
        <StyledVisibilityDate title={t('Candidates visible from date')}>
          {visibilityLabel}
        </StyledVisibilityDate>
      )}
    </StyledSelectOption>
  );
};

export default ControlHRItem;
